<template>
  <div class="m-4 mx-auto my-6 flex max-w-xl flex-col rounded-lg bg-white p-4">
    <p class="text-lg font-normal">
      How long do you require support for?
      <fa-icon
        class="text-vgorange pl-1 text-sm"
        icon="fa-regular fa-asterisk"
      />
    </p>
    <v-select
      v-model="duration"
      data-cy="consult.plandetails.input.duration"
      :error-messages="durationRules"
      :items="durationItems"
      density="compact"
      :label="duration ? '' : 'Please select'"
      variant="outlined"
    ></v-select>
    <p class="text-lg font-normal">
      How soon would you like to start?
      <fa-icon
        class="text-vgorange pl-1 text-sm"
        icon="fa-regular fa-asterisk"
      />
    </p>
    <v-select
      v-model="urgency"
      data-cy="consult.plandetails.dropdown.urgency"
      :error-messages="urgencyRules"
      :items="urgencyItems"
      density="compact"
      :label="urgency ? '' : 'Please select'"
      variant="outlined"
    ></v-select>
    <p class="text-lg font-normal">
      Do you have a monthly budget in mind?
      <fa-icon
        class="text-vgorange pl-1 text-sm"
        icon="fa-regular fa-asterisk"
      />
    </p>
    <v-select
      v-model="monthlyBudget"
      data-cy="consult.plandetails.dropdown.budget"
      :error-messages="monthlyBudgetRules"
      :items="monthlyBudgetItems"
      density="compact"
      :label="monthlyBudget ? '' : 'Please select'"
      variant="outlined"
    ></v-select>
  </div>
</template>

<script>
import { getConsultState } from '@/services/consultService';

export default {
  name: 'PlanDetails',
  props: {
    error: {
      type: Boolean,
      default: null,
    },
  },
  emits: ['update'],
  data() {
    return {
      duration: '',
      durationItems: [
        'I need ongoing support',
        'I need support with a short-term project',
        'Unsure',
      ],
      urgency: '',
      urgencyItems: [
        'As soon as possible',
        'Within 2 weeks',
        'Within the next month',
        'Future needs',
      ],
      monthlyBudget: '',
      monthlyBudgetItems: [
        'Less than $350',
        '$350 to $999',
        '$1,000 to $4,999',
        '$5,000 to $24,999',
        'More than $25,000',
      ],
    };
  },
  computed: {
    durationRules() {
      return this.error === true && !this.duration ? ['required'] : [];
    },
    urgencyRules() {
      return this.error === true && !this.urgency ? ['required'] : [];
    },
    monthlyBudgetRules() {
      return this.error === true && !this.monthlyBudget ? ['required'] : [];
    },
  },
  watch: {
    duration() {
      this.$emit('update', {
        key: 'duration',
        Q: 'How long do you require support for?',
        A: this.duration,
      });
      this.$gtm?.trackEvent({
        event: 'DL - Consult - Support duration',
        value: this.duration,
      });
    },
    urgency() {
      this.$emit('update', {
        key: 'urgency',
        Q: 'How soon would you like to start?',
        A: this.urgency,
      });
      this.$gtm?.trackEvent({
        event: 'DL - Consult - Start preference',
        value: this.urgency,
      });
    },
    monthlyBudget() {
      this.$emit('update', {
        key: 'monthlyBudget',
        Q: 'Do you have a monthly budget in mind?',
        A: this.monthlyBudget,
      });
      this.$gtm?.trackEvent({
        event: 'DL - Consult - Budget preference',
        value: this.monthlyBudget,
      });
    },
  },

  created() {
    this.duration =
      getConsultState()?.questions?.find((item) => item.key === 'duration')
        ?.A || '';
    this.urgency =
      getConsultState()?.questions?.find((item) => item.key === 'urgency')?.A ||
      '';
    this.monthlyBudget =
      getConsultState()?.questions?.find((item) => item.key === 'monthlyBudget')
        ?.A || '';
  },
};
</script>

<style></style>
